(function(){
  function init(root){
    if(!root||root.__dvk) return; root.__dvk=true;
    var SID=root.getAttribute('data-section'), BASE=root.getAttribute('data-url');
    var form=root.querySelector('[data-dvk-form]'), panel=root.querySelector('[data-dvk-panel]');
    var sortInput=root.querySelector('[data-dvk-sort-input]');
    var desktop=window.matchMedia('(min-width: 990px)');
    var ctrl=null, timer=null, rail=0;

    function qs(){
      var fd=new FormData(form), p=new URLSearchParams();
      fd.forEach(function(v,k){ if(String(v).trim()!=='') p.append(k,v); });
      return p.toString();
    }
    function withSection(url){ return url+(url.indexOf('?')>-1?'&':'?')+'section_id='+encodeURIComponent(SID); }
    function state(){
      var open=[]; [].forEach.call(root.querySelectorAll('[data-dvk-facet].is-open'),function(f){ open.push(f.getAttribute('data-dvk-facet')); });
      var all=[]; [].forEach.call(root.querySelectorAll('.dvk-plp__vals.is-all'),function(v){ var f=v.closest('[data-dvk-facet]'); if(f) all.push(f.getAttribute('data-dvk-facet')); });
      var g=root.querySelector('.dvk-plp__groups'); return {open:open,all:all,scroll:g?g.scrollTop:0,pscroll:panel?panel.scrollTop:0};
    }
    function restore(st){
      [].forEach.call(root.querySelectorAll('[data-dvk-facet]'),function(f){
        var i=f.getAttribute('data-dvk-facet'), o=st.open.indexOf(i)>-1||f.classList.contains('is-open');
        if(st.open.length){ o=st.open.indexOf(i)>-1||!!f.querySelector('input:checked'); }
        f.classList.toggle('is-open',o); var b=f.querySelector('[data-dvk-acc]'); if(b) b.setAttribute('aria-expanded',o?'true':'false');
        if(st.all.indexOf(i)>-1){ var v=f.querySelector('.dvk-plp__vals'); if(v) v.classList.add('is-all'); var m=f.querySelector('[data-dvk-showall]'); if(m) m.remove(); }
      });
      setRail(rail);
      var g=root.querySelector('.dvk-plp__groups'); if(g) g.scrollTop=st.scroll; if(panel) panel.scrollTop=st.pscroll;
    }
    function swap(doc,sel){ var a=root.querySelector(sel), b=doc.querySelector(sel); if(a&&b) a.innerHTML=b.innerHTML; }
    function load(url,push){
      if(ctrl){ try{ ctrl.abort(); }catch(e){} }
      ctrl=window.AbortController?new AbortController():null;
      root.classList.add('is-loading');
      var st=state();
      fetch(withSection(url),{signal:ctrl?ctrl.signal:undefined,credentials:'same-origin'})
        .then(function(r){ if(!r.ok) throw new Error(r.status); return r.text(); })
        .then(function(html){
          var doc=new DOMParser().parseFromString(html,'text/html');
          swap(doc,'[data-dvk-results]'); swap(doc,'[data-dvk-facets]'); swap(doc,'[data-dvk-quick]');
          ['[data-dvk-total]','[data-dvk-apply-n]'].forEach(function(s){ var a=root.querySelector(s), b=doc.querySelector(s); if(a&&b) a.textContent=b.textContent; });
          var fa=root.querySelector('[data-dvk-apply]'), fb=doc.querySelector('[data-dvk-apply]'); if(fa&&fb) fa.innerHTML=fb.innerHTML;
          var ma=root.querySelector('[data-dvk-mbadge]'), mb=doc.querySelector('[data-dvk-mbadge]'); if(ma&&mb){ ma.textContent=mb.textContent; ma.hidden=mb.hasAttribute('hidden'); }
          var si=doc.querySelector('[data-dvk-sort-input]'); if(si&&sortInput) sortInput.value=si.value;
          [].forEach.call(root.querySelectorAll('[data-dvk-sortsheet] [data-dvk-sort]'),function(b){ b.classList.toggle('is-on',b.getAttribute('data-dvk-sort')===sortInput.value); });
          restore(st);
          if(push!==false){ try{ history.replaceState({dvkPlp:1},'',url); }catch(e){} }
          root.classList.remove('is-loading');
        })
        .catch(function(e){ if(e&&e.name==='AbortError') return; window.location.href=url; });
    }
    function apply(){ clearTimeout(timer); load(BASE+'?'+qs()); }
    function later(){ clearTimeout(timer); timer=setTimeout(apply,280); }

    form.addEventListener('change',function(e){
      var sg=e.target.getAttribute&&e.target.getAttribute('data-dvk-sizegrp');
      if(sg){ [].forEach.call(root.querySelectorAll('[data-dvk-sizeval="'+sg+'"]'),function(i){ i.checked=e.target.checked; }); }
      if(e.target.matches('[data-dvk-pmin],[data-dvk-pmax]')){ apply(); return; }
      later();
    });
    form.addEventListener('submit',function(e){
      e.preventDefault();
      if(!desktop.matches && panel.classList.contains('is-open')){ closePanel(); }
      apply();
    });
    form.addEventListener('keydown',function(e){ if(e.key==='Enter'&&e.target.matches('input[type=number]')){ e.preventDefault(); apply(); } });

    root.addEventListener('click',function(e){
      var t;
      if((t=e.target.closest('[data-dvk-szrm]'))){
        e.preventDefault(); var g=t.getAttribute('data-dvk-szrm'), px=root.querySelector('[data-dvk-sizegrp="'+g+'"]'); if(px) px.checked=false;
        [].forEach.call(root.querySelectorAll('[data-dvk-sizeval="'+g+'"]'),function(i){ i.checked=false; }); apply(); return;
      }
      if((t=e.target.closest('[data-dvk-link]'))){ e.preventDefault(); load(t.href); return; }
      if((t=e.target.closest('[data-dvk-sort]'))){
        e.preventDefault(); sortInput.value=t.getAttribute('data-dvk-sort'); closeSort(); apply(); return;
      }
      if((t=e.target.closest('[data-dvk-band]'))){
        e.preventDefault();
        var r=t.getAttribute('data-dvk-band').split('-'), mn=root.querySelector('[data-dvk-pmin]'), mx=root.querySelector('[data-dvk-pmax]');
        if(!mn||!mx){ if(t.href) window.location.href=t.href; return; }
        var on=t.classList.contains('is-on');
        mn.value=on?'':(r[0]||''); mx.value=on?'':(r[1]||''); apply(); return;
      }
      if((t=e.target.closest('[data-dvk-acc]'))){
        var f=t.closest('[data-dvk-facet]'), o=!f.classList.contains('is-open'); f.classList.toggle('is-open',o); t.setAttribute('aria-expanded',o?'true':'false'); return;
      }
      if((t=e.target.closest('[data-dvk-showall]'))){ var v=t.previousElementSibling; if(v) v.classList.add('is-all'); t.remove(); return; }
      if((t=e.target.closest('[data-dvk-rail]'))){ setRail(parseInt(t.getAttribute('data-dvk-rail'),10)); return; }
      if((t=e.target.closest('[data-dvk-more]'))){ e.preventDefault(); more(t); return; }
      if(e.target.closest('[data-dvk-open]')){ openPanel(); return; }
      if(e.target.closest('[data-dvk-close]')){ closePanel(); return; }
      if(e.target.closest('[data-dvk-sortopen]')){ openSort(); return; }
      if(e.target.closest('[data-dvk-sortclose]')){ closeSort(); return; }
    });

    function setRail(i){
      rail=i||0;
      var btns=root.querySelectorAll('[data-dvk-rail]'), facets=root.querySelectorAll('[data-dvk-facet]');
      if(rail>=facets.length) rail=0;
      [].forEach.call(btns,function(b){ b.setAttribute('aria-selected',parseInt(b.getAttribute('data-dvk-rail'),10)===rail?'true':'false'); });
      [].forEach.call(facets,function(f){ f.classList.toggle('is-current',parseInt(f.getAttribute('data-dvk-facet'),10)===rail); });
      var g=root.querySelector('.dvk-plp__groups'); if(g&&!desktop.matches) g.scrollTop=0;
    }
    var lastFocus=null;
    function lock(on){ document.documentElement.style.overflow=on?'hidden':''; }
    function openPanel(){ lastFocus=document.activeElement; panel.classList.add('is-open'); lock(true); var x=panel.querySelector('[data-dvk-close]'); if(x) x.focus({preventScroll:true}); }
    function closePanel(){ panel.classList.remove('is-open'); lock(false); if(lastFocus&&lastFocus.focus) lastFocus.focus({preventScroll:true}); }
    var sheet=root.querySelector('[data-dvk-sortsheet]');
    function openSort(){ if(sheet){ sheet.hidden=false; lock(true); } }
    function closeSort(){ if(sheet&&!sheet.hidden){ sheet.hidden=true; lock(false); } }
    document.addEventListener('keydown',function(e){ if(e.key!=='Escape') return; if(panel.classList.contains('is-open')) closePanel(); closeSort(); });
    desktop.addEventListener&&desktop.addEventListener('change',function(){ if(desktop.matches){ panel.classList.remove('is-open'); lock(false); } });

    function more(btn){
      if(btn.getAttribute('aria-busy')==='true') return;
      btn.setAttribute('aria-busy','true'); var label=btn.textContent; btn.textContent='Loading…';
      fetch(withSection(btn.href),{credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(html){
        var doc=new DOMParser().parseFromString(html,'text/html');
        var grid=root.querySelector('[data-dvk-grid]'), ng=doc.querySelector('[data-dvk-grid]');
        if(grid&&ng){ var frag=document.createDocumentFragment(); [].slice.call(ng.children).forEach(function(c){ frag.appendChild(c); }); grid.appendChild(frag); }
        var mw=root.querySelector('[data-dvk-morewrap]'), nw=doc.querySelector('[data-dvk-morewrap]');
        if(mw&&nw) mw.innerHTML=nw.innerHTML; else if(mw) mw.remove();
      }).catch(function(){ window.location.href=btn.href; });
    }
    setRail(0);
  }
  function boot(){ [].forEach.call(document.querySelectorAll('[data-dvk-plp]'),init); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',function(e){ var r=e.target.querySelector('[data-dvk-plp]'); if(r){ r.__dvk=false; init(r); } });
})();

/* Collection description: clamp on mobile with Read more */
(function(){
  function initSeo(){
    document.querySelectorAll('[data-dvk-seo]').forEach(function(b){
      if(b.__dvk) return; b.__dvk=true;
      var btn=b.parentNode.querySelector('[data-dvk-seomore]');
      if(!btn||window.matchMedia('(min-width: 990px)').matches) return;
      b.classList.add('is-clamp');
      if(b.scrollHeight<=b.clientHeight+4){ b.classList.remove('is-clamp'); return; }
      btn.hidden=false;
      btn.addEventListener('click',function(){
        var open=b.classList.toggle('is-clamp')===false;
        btn.setAttribute('aria-expanded',open?'true':'false');
        btn.textContent=open?'Read less':'Read more';
      });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initSeo); else initSeo();
  document.addEventListener('shopify:section:load',initSeo);
})();
